import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthFirmType, UserType } from '../types';
import { LanguageType } from '@core/entity/locale';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Login Spinner start': emptyProps(),
    'Login Spinner stopp': emptyProps(),

    'Legacy Init login': emptyProps(),
    'Legacy Login successful': props<{ token: string }>(),
    'Legacy After login successful': emptyProps(),
    'Set redirect after login successful': props<{ redirectUrl: string }>(),
    'Clear redirect url': emptyProps(),

    'Set firms': props<{ firms: AuthFirmType[] }>(),
    'Select firm': props<{ id: number }>(),

    'Load Current User Successful': props<{ user: UserType & { firm: UserType['firm'] & { id: number } } }>(),
    'Load Current User Failed': props<{ error: unknown }>(),

    'Reload current auth user if not loaded': emptyProps(),
    'Reload current auth user': emptyProps(),
    Logout: emptyProps(),
    'Logout successful': props<{ url: string | null }>(),
    'Reset auth state and storage': emptyProps(),

    'Update Language On Current User': props<{ languageCode: LanguageType }>(),

    // SSO Actions
    'Init Sso login': props<{ useBlAccountAuthenticator: boolean }>(),
    'Sso login successful': props<{ token: string }>(),
    'Sso After login successful': emptyProps(),
    // 'Sso login failed': props<{ error: unknown }>(),

    'After login successful': emptyProps(),
  },
});
